import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { ToastrService } from "ngx-toastr";
import { CreateModuleVersionComponent } from "../create-module-version/create-module-version.component";
import { FirmwareService, Module, ModuleName } from '../services/firmware/firmware.service';
import { ViewModuleVersionModalComponent } from "../view-module-version-modal/view-module-version-modal.component";

@Component({
  selector: 'dcc-module-details',
  templateUrl: './module-details.component.html',
  styleUrls: ['./module-details.component.scss']
})
export class ModuleDetailsComponent implements OnInit {
  @Input() module: ModuleName;

  private gridApi!: GridApi<Module>;
  moduleVersions: Module[] = [];
  nameOfTheModule: string;
  numberOfModuleVersions: number = 0;

  constructor(
    private firmwareService: FirmwareService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(async params => {
      this.nameOfTheModule = params.get('name');
      await this.getCurrentModuleByName(this.nameOfTheModule);
    });
  }

  modalLinkRederer: (params: any) => HTMLElement = (params) => {
    const link = document.createElement('a');
    link.href = '#';
    link.textContent = params.value;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const modal = this.modalService.open(ViewModuleVersionModalComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
      modal.componentInstance.refreshPage.subscribe(async () => await this.refreshAfterNewModuleVersion());
      modal.componentInstance.moduleVersion = params.data;
    });
    return link;
  };

  columnDefs: ColDef[] = [
    { field: 'version', headerName: 'Version', maxWidth: 300, cellRenderer: this.modalLinkRederer },
    { field: 'platform', headerName: 'Platform' },
    { field: 'fileName', headerName: 'FileName' }
  ];

  defaultColDef: ColDef = {
    sortable: false,
    filter: false,
    resizable: true,
    suppressMovable: true
  };

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    await this.getVersionsForCurrentModule(this.nameOfTheModule);
    window.addEventListener('resize', function () {
      setTimeout(function () {
        params.api.sizeColumnsToFit();
      });
    });
    this.gridApi.sizeColumnsToFit();
  }

  async getVersionsForCurrentModule(name: string): Promise<void> {
    try {
      this.moduleVersions = await this.firmwareService.getModuleVersionsByName(name);
      this.numberOfModuleVersions = this.moduleVersions.length;
      this.gridApi.setRowData(this.moduleVersions);
    } catch (error) {
      this.gridApi.setRowData([]);
      this.toastr.error('Failure retrieving data.');
    }
  }

  async getCurrentModuleByName(name: string): Promise<void> {
    try {
      this.module = await this.firmwareService.getModuleByName(name);
    } catch (error) {
      this.toastr.error('Failure retrieving data.');
    }
  }

  onModuleVersionCreateClick() {
    const modal = this.modalService.open(CreateModuleVersionComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
    modal.componentInstance.moduleName = this.nameOfTheModule;
    modal.componentInstance.refreshPage.subscribe(async () => await this.refreshAfterNewModuleVersion());
  }

  async refreshAfterNewModuleVersion() {
    await this.onRefresh();
  }

  async onRefresh() {
    this.gridApi.showLoadingOverlay();
    await this.getVersionsForCurrentModule(this.nameOfTheModule);
    this.gridApi.hideOverlay();
    this.gridApi.sizeColumnsToFit();
  }
}
